import React from 'react';
import Box from '../../components/Box/Box';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';
import TListItemBaseProps from './@types/TListItemBaseProps';
import TListItemBasicProps from './@types/TListItemBasicProps';

const ListItemBase = ({ as, kind, modifiers, children, ...rest }: TListItemBasicProps & TListItemBaseProps) => {
  const conditionalProps = filterConditionalKeyValues({
    modifiers: [kind, ...(modifiers ?? [])],
  });
  return (
    <Box {...conditionalProps} as={as} name="ListItem" {...rest}>
      {children}
    </Box>
  );
};

export default ListItemBase;
